import type {
	SidebarBadgeStyle,
	SidebarSection,
	SidebarVisibility,
} from "@productlane/lib/src/sidebar-layout"

export const SIDEBAR_LAYOUT_COPY = {
	dialogTitle: "Customize sidebar",
	badgeStyleLabel: "Default badge style",
	badgeStyles: {
		count: "Count",
		dot: "Dot",
		off: "Off",
	} satisfies Record<SidebarBadgeStyle, string>,
	visibility: {
		always: "Always show",
		badged: "Show when badged",
		hidden: "Don't show",
	} satisfies Record<SidebarVisibility, string>,
	sections: {
		personal: "Personal",
		inbox: "Inbox",
		workspace: "Workspace",
	} satisfies Record<SidebarSection, string>,
	more: "More",
	reorder: (title: string) => `Reorder ${title}`,
	saveFailed: "Couldn't save your sidebar",
}
